import React from 'react';
import styled from 'styled-components';

import { Loading } from '@/shared/presentation/components/ui/Loading';

import { Modal } from './Modal';

const Container = styled.div`
  padding: 1rem;
  margin: 1rem;
  width: 100%;
  background-color: #ffffff;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
`;

const LoadingWrapper = styled.div`
  width: auto;
`;

const Text = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -0.4px;
  color: #000000;
  flex: 1;
`;

type Props = Partial<{
  text: string;
  children: React.ReactNode;
}>;

export const LoadingModal: React.FC<Props> = (props) => {
  return (
    <Modal width="auto">
      <Container>
        <LoadingWrapper>
          <Loading />
        </LoadingWrapper>
        <Text>{props.text}</Text>
      </Container>
    </Modal>
  );
};

LoadingModal.defaultProps = {
  text: 'Carregando...',
};
